const Trendingdata = {
    productItems : [{
        id: "1",
        name: "Apple",
        description:  "Apple iphone 12 pro",
        price : "400",
        Image : "https://mediacenterpk.com/image/catalog/Apple/03-10-19/Apple/iPhone-12-Pro-Max/128-GB/Grp.png",
        instock : 3
    } ,
    {
        id: "2",
        name: "Samsung",
        description:  "Samsung flip 4",
        price : "700",
        Image : "https://tse4.mm.bing.net/th?id=OIP.J_QE8M_giCXhHObvar6VWQHaIC&pid=Api&P=0",
        instock : 7
    } ,
    {
        id: "3",
        name: "Pixel",
        description:  "Google pixel 7 pro",
        price : "600",
        Image : "https://static1.pocketnowimages.com/wordpress/wp-content/uploads/2022/10/Pixel-7-Pro-Hazel-Close-Up-Resized.jpg",
        instock : 2
    } ,
    {
        id: "4",
        name: "Apple",
        description:  "Apple iphone 12 pro",
        price : "400",
        Image : "https://mediacenterpk.com/image/catalog/Apple/03-10-19/Apple/iPhone-12-Pro-Max/128-GB/Grp.png",
        instock : 4
    } ,
    {
        id: "5",
        name: "Motorola",
        description:  "Edge",
        price : "300",
        Image : "https://838450.smushcdn.com/1730387/wp-content/uploads/2020/04/motorola-edge-midnight-magenta-hero_resize_91.jpg?lossy=1&strip=1&webp=1",
        instock : 7
    } ,
    {
        id: "6",
        name: "Xiaomi",
        description:  "Redmi note 7 pro",
        price : "200",
        Image : "https://tse3.mm.bing.net/th?id=OIP.DmkuuyaBa8frz3eBELyMkwHaHa&pid=Api&P=0",
        instock : 3
    } ,
    {
        id: "7",
        name: "Poco x3",
        description:  "Poco 64GB",
        price : "250",
        Image : "https://tse4.mm.bing.net/th?id=OIP.V1Gm93usw63PKKaxL1wvvAHaHa&pid=Api&P=0",
        
        instock : 4
    } ,
]
}
export default Trendingdata;